/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import cn from "classnames";

const Progress = ({ value = 0 }: { value: string | number }) => {
  return (
    <div className="w-full -bg--component-colors-tab-inactive-default-high h-0.5 rounded-full overflow-hidden">
      <div className={cn("-bg--component-colors-tab-active-default-high h-0.5")} style={{ width: `${value}%` }}></div>
    </div>
  );
};

export default Progress;
